export default __webpack_public_path__ + "static/media/a037-i.ec268c9e.jpg";